import React, { useState, useEffect } from 'react';
import Cupones from './components/Cupones/Cupones';
import Descuentos from './components/Descuentos/Descuentos';
import './CuponesDescuentos.scss';
import { deletePaymentCoupon, getPaymentCouponsByLocalId } from '../../../../crud/payments_api/payment_coupons';
import { deletePaymentDiscount, getPaymentDiscountsByLocalId } from '../../../../crud/payments_api/payment_discounts';
import { Coupon, Discount } from './types';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap'; // Asegúrate de tener react-bootstrap instalado
import { FaPlus, FaMousePointer,FaTimes, FaTrash} from 'react-icons/fa';
import NoAuth from '../../../Base/components/NoAuth/NoAuth';
import { getPermissionState } from '../../../../utils/functions';

const CuponesDescuentos: React.FC = () => {
    // Estado para gestionar qué pestaña está activa
    const [showCoupons, setShowCoupons] = useState<boolean>(true); // true para Cupones, false para Descuentos

    // Estados existentes
    const [cupones, setCoupons] = useState<Coupon[]>([]);
    const [descuentos, setDescuentos] = useState<Discount[]>([]);
    const [showCreateCouponModal, setShowCreateCouponModal] = useState(false);
    const [showCreateDiscountModal, setShowCreateDiscountModal] = useState(false);
    const [showClientCoupon, setShowClientCoupon] = useState(false);
    const [selectionMode, setSelectionMode] = useState(false);
    const [showUpdateDiscountModal, setShowUpdateDiscountModal] = useState(false);
    const [showUpdateCouponModal, setShowUpdateCouponModal] = useState(false);
    const [dynamicallySelectedCoupons, setDynamicallySelectedCoupons] = useState<Coupon[]>([]);
    const [dynamicallySelectedDiscounts, setDynamicallySelectedDiscounts] = useState<Discount[]>([]);
    const [selectedCoupon, setSelectedCoupon] = useState<Coupon | null>(null);
    const [selectedDiscount, setSelectedDiscount] = useState<Discount | null>(null);
    const [isLoadingCuopons, setIsLoadingCoupons] = useState<boolean>(true);
    const [isLoadingDiscounts, setIsLoadingDiscounts] = useState<boolean>(true);

    // Fetch Cupones y Descuentos al montar el componente
    useEffect(() => {
        const userContext = localStorage.getItem('user');
        const localId = userContext != null ? JSON.parse(userContext).local_id : 0;

        const fetchCupones = async () => {
            try {
                const response = await getPaymentCouponsByLocalId(localId);
                setCoupons(response.data);
                setIsLoadingCoupons(false);
            } catch (error) {
                console.error('Error fetching cupones', error);
                toast.error('Error al cargar cupones');
                setIsLoadingCoupons(false);
            }
        };

        const fetchDiscounts = async () => {
            try {
                const response = await getPaymentDiscountsByLocalId(localId);
                setDescuentos(response.data);
                setIsLoadingDiscounts(false);
            } catch (error) {
                console.error('Error fetching descuentos', error);
                toast.error('Error al cargar descuentos');
                setIsLoadingDiscounts(false);
            }
        };

        fetchCupones();
        fetchDiscounts();
    }, []);

    // Función para cancelar la selección
    const handleCancelSelection = () => {
        setSelectionMode(false);
        setDynamicallySelectedCoupons([]);
        setDynamicallySelectedDiscounts([]);
    };

    // Toggle de selección de descuento
    const toggleDiscountSelection = (discount: Discount) => {
        if (selectionMode) {
            if (dynamicallySelectedDiscounts.includes(discount)) {
                setDynamicallySelectedDiscounts(dynamicallySelectedDiscounts.filter(d => d !== discount));
            } else {
                setDynamicallySelectedDiscounts([...dynamicallySelectedDiscounts, discount]);
            }
        } else {
            setSelectedDiscount(discount);
        }
    };

    // Toggle de selección de cupón
    const toggleCouponSelection = (coupon: Coupon) => {
        if (selectionMode) {
            if (dynamicallySelectedCoupons.includes(coupon)) {
                setDynamicallySelectedCoupons(dynamicallySelectedCoupons.filter(c => c !== coupon));
            } else {
                setDynamicallySelectedCoupons([...dynamicallySelectedCoupons, coupon]);
            }
        } else {
            setSelectedCoupon(coupon);
        }
    };

    // Manejar eliminación de descuentos
    const handleDeleteDiscount = async () => {
        for (const discount of dynamicallySelectedDiscounts) {
            try {
                console.log('Discount to delete:', discount.payment_discount_id);
                await deletePaymentDiscount(discount.payment_discount_id);
                console.log('Discount deleted:', discount.payment_discount_id);
                toast.success('Descuento eliminado exitosamente');
                setDescuentos(descuentos.filter(d => d.payment_discount_id !== discount.payment_discount_id));
            } catch (error) {
                toast.error('Error eliminando descuento');
                console.error('Error deleting discount:', error);
            }
        }
        setDynamicallySelectedDiscounts([]);
        setSelectionMode(false);
    };

    // Manejar eliminación de cupones
    const handleDeleteCoupon = async () => {
        for (const coupon of dynamicallySelectedCoupons) {
            try {
                console.log('Coupon to delete:', coupon.payment_coupon_id);
                await deletePaymentCoupon(coupon.payment_coupon_id);
                console.log('Coupon deleted:', coupon.payment_coupon_id);
                toast.success('Cupón eliminado exitosamente');
                setCoupons(cupones.filter(c => c.payment_coupon_id !== coupon.payment_coupon_id));
            } catch (error) {
                toast.error('Error eliminando cupón');
                console.error('Error deleting coupon:', error);
            }
        }
        setDynamicallySelectedCoupons([]);
        setSelectionMode(false);
    };

    // Renderizar la sección de pestañas (Cupones y Descuentos)
    const renderTabs = () => {
        return (
            <div className="mp-button-selector-page-container">
                <div className="mp-button-selector-page-selector">
                    
                        <Button
                            onClick={() => setShowCoupons(true)}
                            className={`mp-button-selector-page-button ${showCoupons ? 'active' : 'inactive'}`}
                            variant="none"
                            aria-pressed={showCoupons}
                            aria-label="Mostrar Cupones"
                        >
                            Cupones
                        </Button>
                        <Button
                            onClick={() => setShowCoupons(false)}
                            className={`mp-button-selector-page-button ${!showCoupons ? 'active' : 'inactive'}`}
                            variant="none"
                            aria-pressed={!showCoupons}
                            aria-label="Mostrar Descuentos"
                        >
                            Descuentos
                        </Button>
                    
                </div>
            </div>
        );
    };

    // Renderizar los demás botones (Crear, Seleccionar, etc.)
    const renderHeader = () => {
        const isCoupons = showCoupons;
        const handleDelete = isCoupons ? handleDeleteCoupon : handleDeleteDiscount;
        // Contador de seleccionados
        const selectedCount = isCoupons ? dynamicallySelectedCoupons.length : dynamicallySelectedDiscounts.length;

        // Only render the title here; action buttons are rendered separately
        return (
            <div className="cupones-descuentos-header-container">
                <h2 className="cupones-descuentos-header-title">{isCoupons ? "Cupones" : "Descuentos"}</h2>
            </div>
        );
    };

    // Mostrar spinner de carga si es necesario
    if (isLoadingCuopons || isLoadingDiscounts) {
        return <LoadingSpinner text="Procesando..." transparent={true} />;
    }

    const renderActionButtons = () => (
        <div className="menu-buttons">
            <Button
                onClick={showCoupons ? () => setShowCreateCouponModal(true) : () => setShowCreateDiscountModal(true)}
                className={`filter-button create-item-button`}
                variant="none"
                disabled={showCoupons ? !getPermissionState(31) : !getPermissionState(32)}
            >
                <FaPlus /> <span style={{ marginLeft: 8 }}>{showCoupons ? "Crear cupón" : "Crear descuento"}</span>
            </Button>

            {selectionMode ? (
                <>
                    <Button className={`filter-button selection-button`} variant="none" onClick={handleCancelSelection}>
                        <FaTimes style={{ marginBottom: '2px' }} /> <span style={{ marginLeft: 8 }}>Cancelar selección</span>
                    </Button>

                    <Button
                        className={`filter-button delete-selection-button`}
                        variant="none"
                        onClick={showCoupons ? handleDeleteCoupon : handleDeleteDiscount}
                        disabled={!getPermissionState(showCoupons ? 98 : 100) || (showCoupons ? dynamicallySelectedCoupons.length === 0 : dynamicallySelectedDiscounts.length === 0)}
                    >
                        {((showCoupons ? dynamicallySelectedCoupons.length : dynamicallySelectedDiscounts.length) > 0) && <span style={{ marginRight: '6px' }}>({showCoupons ? dynamicallySelectedCoupons.length : dynamicallySelectedDiscounts.length})</span>}
                        <FaTrash style={{ marginBottom: '2px' }} /> <span style={{ marginLeft: 6 }}>Eliminar selección</span>
                    </Button>
                </>
            ) : (
                <>
                    <Button className={`filter-button selection-button`} variant="none" onClick={() => setSelectionMode(true)}>
                        <FaMousePointer style={{ marginBottom: '2px' }} /> <span style={{ marginLeft: 8 }}>Seleccionar</span>
                    </Button>
                </>
            )}
        </div>
    );

    return (
        <div className="cupones-descuentos-container">
            {/* Encabezado (solo título) */}
            <div className="cupones-descuentos-header-top">
                {renderHeader()}
            </div>

            {/* Mobile action buttons similar to Items FilterBar */}
            <div className="cupones-mobile-action-row mobile-only">
                <div className="mobile-action-buttons">
                    <Button
                        onClick={showCoupons ? () => setShowCreateCouponModal(true) : () => setShowCreateDiscountModal(true)}
                        className={`filter-button create-item-button`}
                        variant="none"
                        disabled={showCoupons ? !getPermissionState(31) : !getPermissionState(32)}
                    >
                        <FaPlus />
                    </Button>

                    {selectionMode ? (
                        <>
                            <Button className={`filter-button selection-button`} variant="none" onClick={handleCancelSelection}>
                                <FaTimes />
                            </Button>

                            <Button
                                className={`filter-button delete-selection-button`}
                                variant="none"
                                onClick={showCoupons ? handleDeleteCoupon : handleDeleteDiscount}
                                disabled={!getPermissionState(showCoupons ? 98 : 100) || (showCoupons ? dynamicallySelectedCoupons.length === 0 : dynamicallySelectedDiscounts.length === 0)}
                            >
                                <FaTrash />
                                {((showCoupons ? dynamicallySelectedCoupons.length : dynamicallySelectedDiscounts.length) > 0) && (
                                    <span style={{ marginLeft: '4px' }}>({showCoupons ? dynamicallySelectedCoupons.length : dynamicallySelectedDiscounts.length})</span>
                                )}
                            </Button>
                        </>
                    ) : (
                        <Button className={`filter-button selection-button`} variant="none" onClick={() => setSelectionMode(true)}>
                            <FaMousePointer />
                        </Button>
                    )}
                </div>
            </div>

            {/* Botones externos para alternar entre Cupones y Descuentos */}
            {renderTabs()}

            {/* Desktop action buttons placed under the tabs */}
            <div className="cupones-desktop-action-row desktop-only">
                {renderActionButtons()}
            </div>

            {/* Contenido principal */}
            <div>
                {showCoupons ? (
                    getPermissionState(29) ? (
                        <Cupones
                            cupones={cupones}
                            setCupones={setCoupons}
                            showCreateCouponModal={showCreateCouponModal}
                            setShowCreateCouponModal={setShowCreateCouponModal}
                            showUpdateCouponModal={showUpdateCouponModal}
                            setShowUpdateCouponModal={setShowUpdateCouponModal}
                            dynamicallySelectedCoupons={dynamicallySelectedCoupons}
                            toggleCouponSelection={toggleCouponSelection}
                            selectionMode={selectionMode}
                            showClientCoupon={showClientCoupon}
                            setShowClientCoupon={setShowClientCoupon}
                            selectedCoupon={selectedCoupon}
                            setSelectedCoupon={setSelectedCoupon}
                        />
                    ) : (
                        <NoAuth />
                    )
                ) : (
                    getPermissionState(30) ? (
                        <Descuentos
                            descuentos={descuentos}
                            setDescuentos={setDescuentos}
                            showCreateDiscountModal={showCreateDiscountModal}
                            showUpdateDiscountModal={showUpdateDiscountModal}
                            setShowCreateDiscountModal={setShowCreateDiscountModal}
                            setShowUpdateDiscountModal={setShowUpdateDiscountModal}
                            selectionMode={selectionMode}
                            dynamicallySelectedDiscounts={dynamicallySelectedDiscounts}
                            toggleDiscountSelection={toggleDiscountSelection}
                        />
                    ) : (
                        <NoAuth />
                    )
                )}
            </div>
        </div>
    );
};

export default CuponesDescuentos;
